import { Container, RowContent, RowSubtitle, RowTitle, TextSmall } from './CookieInformation.style';
import { CookieInformationLabels, Disclosure } from '@usercentrics/cmp-browser-sdk';
import { Fragment, FunctionalComponent, h } from 'preact';
import { convertCookieMaxAge, convertDomain } from '../StorageInfo/helpers';
import { memo } from 'preact/compat';
import { useDeviceState } from '../../hooks';

interface DetailedCookieInformationProps extends Disclosure {
  labels: CookieInformationLabels;
}

const CookieInformation: FunctionalComponent<DetailedCookieInformationProps> = memo(
  ({ description = null, domain = null, identifier = '', maxAgeSeconds, labels, name = '', type }) => {
    const { isMobile } = useDeviceState();

    return (
      <Fragment>
        {(name || identifier) && (
          <RowTitle>
            {name ? `${labels.name}: ${name}` : ''}
            {name && identifier ? ' | ' : ''}
            {identifier ? `${labels.identifier}: ${identifier}` : ''}
          </RowTitle>
        )}
        {description && <RowSubtitle>{description}</RowSubtitle>}
        <RowContent>
          <Container>
            <TextSmall size={2}>{`${labels.duration}: ${convertCookieMaxAge(maxAgeSeconds, labels)}`}</TextSmall>
            <TextSmall size={1}>{`${labels.type}: ${type}`}</TextSmall>
          </Container>
          {domain && (
            <TextSmall withTopMargin={isMobile} size={2}>
              {`${labels.domain}: ${convertDomain(domain, labels.anyDomain, labels.multipleDomains)}`}
            </TextSmall>
          )}
        </RowContent>
      </Fragment>
    );
  },
);

export default CookieInformation;
